<template>
    <div >
      <b-row>
          <b-col md="12">
                <MdTitle v-bind:Text="$t('ItemExpFiltersRep.ReportTitle')" />
          </b-col>
      </b-row>
      <b-row>
          <div class="col-sm-12 col-md-12 mb-4">
              <div class="textlabel" :data-label="this.$t('Shared.SearchElements')">
                  <div class="input-group"  dir="ltr">
                      <input type="text" class="form-control" v-model="parameter.SearchCriteria"
                          @keyup.enter="LoadAItemExtp" />

                      <div class="input-group-append">
                          <MdButton v-bind:Name="'btnsearchinput'" v-bind:VariantProp="'btn btn-sm search-attached'"
                              v-bind:IconClass="'mdi mdi-magnify'" v-on:click="LoadAItemExtp">
                          </MdButton>
                      </div>
                  </div>
              </div>
          </div>
      </b-row>
      <b-row>
          <b-col lg="3" md="3" sm="12">
            <!--<MdEdit 
              v-bind:Label="$t('Shared.datefrom')"
              v-bind:TypeProp="'date'" 
              v-bind:Name="'datefrom'"
              v-bind:Min="'1900-01-01'"
              v-bind:Max="'2200-12-31'"
              v-model="dateFrom"
              v-bind:isRequired="false">                                     
            </MdEdit>-->
            <MdDateTime 
              :Label="$t('Shared.datefrom')" 
              :Model="dateFrom"                           
              @input="dateFrom = $event"                            
              :Id="'ItemExpFiltersRepDateFrom'"
              :Type="'date'"  
              :OnPressEnter="LoadAItemExtp"            
              :isRequired="false"                           
              :isConfirm="false"
              :ReadOnly="false">
            </MdDateTime>
          </b-col>
          <b-col lg="3" md="3" sm="12">
            <!--<MdEdit 
              v-bind:Label="$t('Shared.dateTo')"
              v-bind:TypeProp="'date'" 
              v-bind:Name="'dateto'"
              v-bind:Min="'1900-01-01'"
              v-bind:Max="'2200-12-31'"
              v-model="dateTo"
              v-bind:isRequired="false">                                     
            </MdEdit>-->
            <MdDateTime 
                :Label="$t('Shared.dateTo')" 
                :Model="dateTo"                           
                @input="dateTo = $event"                            
                :Id="'ItemExpFiltersRepDateTo'"
                :OnPressEnter="LoadAItemExtp"    
                :Type="'date'"             
                :isRequired="false"                           
                :isConfirm="false"
                :ReadOnly="false">
            </MdDateTime>
          </b-col>
          <b-col lg="3" md="3" sm="12">         
            <MdSelect
              v-bind:Label="$t('Medication.Drugs')"
              v-bind:Options="DrugList"
              v-bind:Model="DrugsCodeModel"
              v-bind:FieldDescription="'drugname'"
              v-bind:FieldCode="'drugCode'"
              v-bind:Multiple="true"             
              :Input="ChangeDrugs"/>
          </b-col>
          <b-col lg="3" md="3" sm="12">
            <MdSelect
                v-bind:Label="$tc('ePharmacyItemsReceived.Location')"
                v-bind:Options="LocList"
                v-bind:Model="LocCodeModel"
                v-bind:FieldDescription="'name'"
                v-bind:FieldCode="'code'" 
                v-bind:Multiple="true"                      
                :Input="ChangeLocation"/>
          </b-col>
          <b-col lg="3" md="3" sm="12">
            <MdEdit 
                v-bind:Label="$t('ePharmacyItemsReceived.BatchNo')"
                v-bind:TypeProp="'text'" 
                v-bind:Name="'lots'"
                v-model="lots"
                >                                     
              </MdEdit>
          </b-col>
          <b-col lg="6" md="6" sm="12"></b-col>
          <b-col lg="3" md="3" sm="12">
            <div class="text-md-right mt-3">
                <button 
                    v-on:click="LoadAItemExtp"
                    type="button"
                    class="btn btn-primary btn-login mx-2"												
                    id="btnsearchinput">
                    {{ $t('Shared.Search') }}
                </button>
            </div>
          </b-col> 
     
        </b-row>
        <div class="row">
          <div class="col-12 mt-2">
             <MdTitle  v-bind:Text="$t('Shared.SearchResult')" 
                          v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>

            <div class="row">
              <div class="col-md-12">
               
                  <MdTable 
                    v-bind:fields="fields"
                    v-bind:items="items"
                    v-bind:totalRows="totalRows"
                    v-bind:showMessageIsEmpty="ShowMessageIsEmpty"
                    v-bind:currentPage="currentPage"
                    v-bind:perPage="perPage"
                    v-bind:pageOptions="pageOptions"
                    v-bind:refTable="refTable"
                    :pageChanged="pageChanged"
                    :perPageFunction="PerPageFunction"
                    v-bind:FieldsDate="FieldsDateArr">
                  </MdTable>
              </div>
            </div>
          </div>
        </div>
        <div class="space-actions"></div>
        <div class="page-actions">
          <MdButton
            v-bind:Label="$t('Shared.Back')"
            v-bind:ClassProp="'primary btn-login mx-2'"
            v-on:click="reportList"
            v-bind:Name="'btn_ReportList'"/>
          <MdButton
            v-bind:Label="$t('Shared.Report')"
            v-bind:ClassProp="'primary btn-login mx-2'"
            v-on:click="onClickShowReport"
            v-bind:Name="'btn_Print'"/>

          <b-dropdown id="dropdown-dropup" dropup :text="$t('Shared.Export')" variant="primary" class="m-2">
						<b-dropdown-item v-on:click="handlePdf('export')">{{$t('Shared.PDF')}}</b-dropdown-item>
						<b-dropdown-item v-on:click="handlePdf('email')">{{$t('Shared.PDFByEmail')}}</b-dropdown-item>
						<b-dropdown-item v-on:click="handleCSV('export')">{{$t('Shared.CSV')}}</b-dropdown-item>
						<b-dropdown-item v-on:click="handleCSV('email')">{{$t('Shared.CSVByEmail')}}</b-dropdown-item>
					</b-dropdown>   
        </div>

      
      <DxPopup
        :visible="isReportVisible"
        :drag-enabled="true"
        :close-on-outside-click="false"
        :show-close-button="true"
        :show-title="true"
        :hide-on-parent-scroll="true"
        :title="$t('ItemExpFiltersRep.ReportTitle')"
        @hidden="onHiddenReport"
        :resize-enabled="true"
        shading-color="rgba(0, 0, 0, 0.5)"
        height="94vh"
        width="97vw"
        @showing="onShowing"
      >
        <ReportViewer
          ref="reportPatientActFilters"
          :ReportName="'ItemExpirationList'"
          :ReportTitle="$t('ItemExpFiltersRep.ReportTitle')"
          :IsAnAPIReport="true"
        />
    </DxPopup>

    <CSVExportHelper
        ref="csvExportHelper"
        v-bind:conformSubject="$t('ItemExpFiltersRep.ReportTitle')"
        v-bind:sendEmailAPI="'/ItemExpiration/email'"
        v-bind:exportCsvAPI="'/ItemExpiration/exportCSV'"
    >    
    </CSVExportHelper>
    </div>
</template>

<script>
  import Vue from 'vue'
  import { DxPopup } from 'devextreme-vue/popup';
  import ShowMessage from '@/components/messages/ShowMessage.js'
  import DBFunctions from '@/common/DBFunctions.js'
  import PharmacyRepFunctions from '@/common/PharmacyRepFunctions.js'
  import UtilsService from '@/services/utils.service'
  import Utils from "@/common/utils";
  import { EventBus } from '@/event-bus.js';

  export default Vue.extend({
      name: "ItemExpFiltersRep",
      mixins: [ ShowMessage, DBFunctions, PharmacyRepFunctions ],
      components: { DxPopup },
      data() {
          return {
              isParamVisible: true,
              isReportVisible: false,
              dateFrom:null,
              dateTo: null,
              lots: '',
              reportParams: [],
              DrugList:[],
              DrugsCodeModel:'',
              LocCodeModel:'',
              LocList:[],
              parameter:{
                SearchCriteria:'',
                PageNumber : 0,
                PageSize:0       
              },
              params: {
                DrugList: '',
                LocList: ''
              },
              items: [],         
              fields: [
                { key: 'ItemNo', sortable: true, label: this.$t('ItemExpFiltersRep.ItemNo'), class: 'text-left' },
                { key: 'ItemCode', sortable: true, label: this.$t('ItemExpFiltersRep.ItemCode'), class: 'text-left' },
                { key: 'DrugCode', sortable: true, label: this.$t('drug.DrugCode'), class: 'text-left' },
                { key: 'DrugName', sortable: true, label: this.$t('drug.Drugname'), class: 'text-left' },
                { key: 'ActiveIngred', sortable: true, label: this.$t('ItemExpFiltersRep.ActiveIngredient'), class: 'text-left' },
                { key: 'DrugType', sortable: true, label: this.$t('Shared.DrugType'), class: 'text-left' },
                { key: 'Controlled', sortable: true, label: this.$t('ItemExpFiltersRep.Controlled'), class: 'text-left' },
                { key: 'BatchNo', sortable: true, label: this.$t('ItemExpFiltersRep.BatchNo'), class: 'text-left' },
                { key: 'LotNo', sortable: true, label: this.$t('ItemExpFiltersRep.LotNo'), class: 'text-left' },
                { key: 'ExpirationDate', sortable: true, label: this.$t('ItemExpFiltersRep.ExpirationDate'), class: 'text-left' },
                { key: 'DateReceived', sortable: true, label: this.$t('ItemExpFiltersRep.DateReceived'), class: 'text-left' },
                { key: 'Location', sortable: true, label: this.$t('ItemExpFiltersRep.Location'), class: 'text-left' },
                { key: 'QTYReceived', sortable: true, label: this.$t('ItemExpFiltersRep.QTYReceived'), class: 'text-left' },
                { key: 'QTYAvailable', sortable: true, label: this.$t('ItemExpFiltersRep.QTYAvailable'), class: 'text-left' },
                { key: 'QTYFilled', sortable: true, label: this.$t('ItemExpFiltersRep.QTYFilled'), class: 'text-left' },
                { key: 'InQTYFilled', sortable: true, label: this.$t('ItemExpFiltersRep.InQTYFilled'), class: 'text-left' },
                { key: 'OutQTYFilled', sortable: true, label: this.$t('ItemExpFiltersRep.OutQTYFilled'), class: 'text-left' },
                { key: 'QTYremoved', sortable: true, label: this.$t('ItemExpFiltersRep.QTYRemoved'), class: 'text-left' }
              ],
              pageOptions: [5, 10, 15 ],
              totalRows: 0,
              currentPage: 1,
              perPage: 10,
              selected: [],
              Header:{},
              refTable: 'selectableTable', 
              ShowMessageIsEmpty:true,
              FieldsDateArr:['dateFrom','dateTo'],  
          }
      },
      methods: {

          onShowing(e) {
            let contentElement = e.component.content();
            let titleElement = e.component._$title[0]
            contentElement.style.padding = '0px';
            titleElement.style.padding = '0px 20px'
          },

          onHiddenReport() {
            this.isReportVisible = false
          },
       
          onClickClose() {
            this.isParamVisible = false;
          },

          reportList() {
              this.checkExistFavorite('/app/reports/pharmacy');
              this.$router.push({ name: "reportListPharmacy" }).catch(()=>{});
          },

           initializePdfParameters() {
            this.reportParams = []
            this.reportParams.push({ paramName: 'pStartDate', paramValue: this.dateFrom})
            this.reportParams.push({ paramName: 'pEndDate', paramValue: this.dateTo})
            this.reportParams.push({ paramName: 'pDrogList',paramValue: this.params.DrugList })
            this.reportParams.push({ paramName: 'pLocList',paramValue: this.params.LocList })
            this.reportParams.push({ paramName: 'plots', paramValue: this.lots})
            this.reportParams.push({ paramName: 'pSearchCriteria', paramValue: this.parameter.SearchCriteria})
            this.reportParams.push({ paramName: 'isUAE',  paramValue: this.$store.state.companies.isUAE})
          },

          onClickShowReport() {
            this.isParamVisible = false
            this.initializePdfParameters();
            this.isReportVisible = true
            this.$refs.reportPatientActFilters.buildDocument(this.reportParams)
          },

          LoadAItemExtp() {
            this.items = [];
            this.currentPage = 1;
            this.parameter.PageNumber = 1;
            this.totalRows = this.items.length;
            this.getListing();
          },

          initializeParameters() {
           
            // Asignaciones condicionales
            this.parameter.DrugList = this.params.DrugList && this.params.DrugList !== '' 
                ? this.params.DrugList 
                : null;
            
            this.parameter.DateFrom = this.dateFrom;
            this.parameter.DateTo = this.dateTo;
            this.parameter.LotNo = this.lots && this.lots !== '' 
                ? this.params.LocList
                : null;
            this.parameter.LocList = this.params.LocList && this.params.LocList !== '' 
                ? this.params.LocList
                : null;
          },

          getListing() {
            this.parameter.PageNumber = this.currentPage;
            this.parameter.PageSize = this.perPage;

            const procedureName = 'sp_iss_LetterTemplateItemsExpiration'; 
            this.initializeParameters();

            const spParameters = {
                SearchCriteria: this.parameter.SearchCriteria,
                DateFrom: this.parameter.DateFrom,
                DateTo: this.parameter.DateTo,
                Lots: this.parameter.LotNo,
                DrugCode: this.parameter.DrugList,
                Locations: this.parameter.LocList
            };
            
            const request = {
                procedureName: procedureName,
                parameters: spParameters,
                pageNumber: this.parameter.PageNumber,
                pageSize: this.parameter.PageSize
            };

            UtilsService.getExecuteSP(request)
              .then(response => {
                  if (response.status == "200" && response.data) {
                      this.items = response.data;
                   
                      this.items.forEach(function(element) {
                        let { DateReceived, ExpirationDate } = element
                        if (DateReceived) element.DateReceived = Utils.formatterDateToString(DateReceived);
                        if (ExpirationDate) element.ExpirationDate = Utils.formatterDateToString(ExpirationDate);            
                      });
                      let headerString = response.headers["x-pagination"];
                      this.Header = JSON.parse(headerString);
                      this.totalRows = this.Header.TotalCount;
                      this.showEmptyRecords = response.data && response.data.length == 0 ? true : false
                      this.$emit('showEmptyRecords', this.showEmptyRecords);
                  }
              })
              .catch(error => {
                  this.showResponseErrorMessage(error);
              });
          },
          pageChanged (page) {            
            this.currentPage = page;
            this.getListing();    
          },

          PerPageFunction(perpage){
            this.perPage = perpage;  
            this.currentPage = 1;
            this.getListing();
          },

          handleCSV(action) {
            this.initializeParameters();
            switch(action) {
              case 'export':
                this.$refs.csvExportHelper.exportCSV(this.parameter);
              break;
              case 'email':
                this.$refs.csvExportHelper.emailCSV(this.parameter);
              break;
              default:
                console.warn('unknow action:', action);
              break;
            }
          },

          handlePdf(action) {
            this.initializePdfParameters();
            switch(action) {
              case 'export':
                this.$refs.csvExportHelper.exportToPdf('ItemExpirationList', true, false, this.reportParams);
              break;
              case 'email':
                this.$refs.csvExportHelper.emailPdf('ItemExpirationList', true, false, this.reportParams);
              break;
              default:
                console.warn('unknow action:', action);
              break;
            }
          },
      },
      
      mounted () {
        this.getDrugsFilter();
        this.getLocationsFilter();
        EventBus.$on("ShowWeel", function (isShow) { 
            isShow ? this.$emit('load', true) : this.$emit('load', false);     
        }.bind(this));
      },
  })
</script>
<style>
  .dxrd-report-preview-holder {  
      height: 94% !important; 
  } 
</style>
